import {
  ArrowRight,
  Delete,
  DeleteForever,
  DeviceHub,
  Edit,
  Home,
  HomeWork,
  Lan,
  Link,
  LocationCity,
  LockPersonOutlined,
  MoreVert,
  Public,
  Share,
  SignalCellularConnectedNoInternet4BarOutlined,
  SignalCellularNodataOutlined,
} from "@mui/icons-material";
import {
  Box,
  Card,
  CardActionArea,
  Divider,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Stack,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../../services/api";
import AlertModal from "../../alertModal";
import NewMapFtth from "../newMapFtth";
import ModalShareMap from "./modalShareMap";
import ModalAcessosMapa from "../cardMapsHome/modalAcessosMapa";
import useStyles from "./styles";
import usePermissao from "../../../hooks/usePermissao";

function AlertIcons({ styles, number = 0, severity = "warning" }) {
  const color =
    severity === "disaster"
      ? "color.zabbixSeverty.disaster"
      : "color.zabbixSeverty.average";
  const renderTooltip =
    severity === "disaster"
      ? `Offline: ${number}`
      : `Baixa potência: ${number}`;
  return (
    <Tooltip title={renderTooltip}>
      <Box sx={[styles.iconsCircle, { backgroundColor: color }]}>
        <Typography sx={styles.subtitleAlert}>{number.toString()}</Typography>

        {severity === "disaster" ? (
          <SignalCellularNodataOutlined
            sx={{
              ...styles.icons,
            }}
          />
        ) : (
          <SignalCellularConnectedNoInternet4BarOutlined sx={styles.icons} />
        )}
      </Box>
    </Tooltip>
  );
}
function SubMenu({
  anchorElSubmenu,
  openSubmenu,
  setAnchorElSubmenu,
  handleClose,
  setOpenModalShare,
  handleCopy,
  hasLink = false,
  theme = {},
}) {
  const isMdDown = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <Popper
      //open={true}
      id="basic-menu-submenu"
      sx={{ zIndex: 1300 }}
      anchorEl={anchorElSubmenu}
      open={openSubmenu}
      onClose={() => {
        setAnchorElSubmenu(null);
      }}
      placement={isMdDown ? "bottom-end" : "right-start"}
    >
      <Paper
        elevation={4}
        sx={{ bgcolor: theme.palette.mode === "dark" ? "#222222" : "none" }}
      >
        <MenuList>
          <MenuItem
            onClick={() => {
              handleClose();
              setOpenModalShare(true);
            }}
          >
            <ListItemIcon>
              <Share fontSize="small" color="primary" />
            </ListItemIcon>
            <ListItemText>Compartilhar</ListItemText>{" "}
          </MenuItem>
        </MenuList>

        <MenuList>
          <MenuItem
            disabled={!hasLink}
            onClick={() => {
              handleClose();
              handleCopy();
            }}
          >
            <ListItemIcon>
              <Link fontSize="small" color="primary" />
            </ListItemIcon>
            <ListItemText>Copiar Link</ListItemText>{" "}
          </MenuItem>
        </MenuList>
      </Paper>
    </Popper>
  );
}
export default function CardMapsHomeRp({
  id = "",
  mapName = "Desconhecido",
  tipo = 0,
  hostsNames = [],
  hostsCounts = 0,
  popsCounts = 0,
  mapasCounts = 0,
  editMode = false,
  handleDelete,
  index = "",
  inGroup = true,
  disabled = false,
  updateTitleInMaps = () => {},
  setSnackbar = () => {},
  deleteMapsInMaps = () => {},
  duplicateMapsInMaps = () => {},
  updateMapTokenInMaps = () => {},
  updateMapAccessInMaps = () => {},
  alertas = [],
  mapas = [],
  pops = [],
  mapToken,
  mapAccess,
  ftthFilter,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElSubmenu, setAnchorElSubmenu] = useState(null);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openAlertsModal, setOpenAlertsModal] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [openModalAcessos, setOpenModalAcessos] = useState(false);
  const [newTitle, setNewTitle] = useState(mapName);
  const [loadinButtom, setLoadingButtom] = useState(false);
  const [disableButton, setDisableButton] = useState(false);
  const [openModalShare, setOpenModalShare] = useState(false);
  const navigate = useNavigate();
  const theme = useTheme();
  const isMdDown = useMediaQuery(theme.breakpoints.down("md"));
  const styles = useStyles(theme, editMode);

  const currentUser = JSON.parse(localStorage.getItem("1") || "{}");
  const currentUserRole = currentUser?.usuarioCliente?.codigoPermissao ?? "";
  const currentUserId = currentUser?.refreshToken?.usuarioClienteId ?? "";
  const isAdmin = currentUserRole === "adm001" || currentUserRole === "adm002";
  const { canEdit } = usePermissao("easyMaps");

  const open = Boolean(anchorEl);
  const openSubmenu = Boolean(anchorElSubmenu);

  // Mapa FTTH criado com filtros? Só esses podem ser excluídos; o mapa base
  // gerado automaticamente (sem filtros) não tem a opção de exclusão.
  const isFiltered =
    !!ftthFilter &&
    typeof ftthFilter === "object" &&
    Object.keys(ftthFilter).length > 0;

  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleCopy = () => {
    const url = `${window.location.origin}/easyMaps/mapa/public/onus/${id}/${mapToken.token}`;
    navigator.clipboard.writeText(url);
    setSnackbar({
      children: "Campo copiado!",
      severity: "info",
    });
  };

  const handleMouseDown = (event) => {
    if (disabled) return;
    const url = `${window.location.origin}/easyMaps/mapa/onus/${id}`;
    if (event.button === 1) {
      window.open(url, "_blank");
    }
  };

  async function handleApiDelete() {
    try {
      setDisableButton(true);
      const logString = localStorage.getItem("logs");
      const logsId = logString ? JSON.parse(logString)?.id : null;
      const response = await api.post("/easyMaps/map/delete", {
        mapId: id,
        logsLoginClienteId: logsId || "",
      });

      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível excluir o mapa",
          severity: "error",
        });
      } else {
        if (response.data) {
          setOpenDeleteModal(false);
          deleteMapsInMaps(id);
          setAnchorEl(null);
        }
      }
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: `Error:${error?.message || "Não foi possível se conectar com o servidor"}`,
        severity: "error",
      });
    } finally {
      setDisableButton(false);
    }
  }

  const totalONUS = Array.isArray(hostsCounts)
    ? hostsCounts?.reduce((acc, current) => {
        return acc + current;
      }, 0)
    : hostsCounts;
  const totalCTOS = Array.isArray(mapasCounts)
    ? mapasCounts?.reduce((acc, current) => {
        return acc + current;
      }, 0)
    : mapasCounts;

  const color =
    tipo === 0
      ? theme.palette.primary.main
      : tipo === 1
        ? theme.palette.secondary.main
        : tipo === 2
          ? theme.palette.warning.main
          : tipo === 3
            ? theme.palette.info.main
            : theme.palette.sucess.main;

  return (
    <Card sx={{ ...styles.card, flexGrow: 1 }} variant="outlined" index={index}>
      {editMode && (
        <Tooltip title={"Clique para remover do grupo"} placement="top" arrow>
          <CardActionArea
            sx={styles.deleteCardAction}
            onClick={(event) => {
              event.stopPropagation();
              handleDelete(id);
            }}
          >
            <DeleteForever sx={styles.deleteIcon} color={"primary"} />
          </CardActionArea>
        </Tooltip>
      )}
      <Tooltip
        title={
          disabled
            ? "Configure uma fonte de dados (QuestDB ou ERP) nas configurações para acessar este mapa"
            : ""
        }
      >
        <CardActionArea
          sx={{
            ...styles.cardAction,
            ...(disabled ? { opacity: 0.55, cursor: "default" } : {}),
          }}
          disableRipple={disabled}
          onClick={() => {
            if (disabled) return;
            navigate(`/easyMaps/mapa/onus/${id}`);
          }}
          onMouseDown={handleMouseDown}
        >
          <Box sx={styles.cardType(color)}>
            {tipo === 0 && (
              <Typography sx={styles.typeText(color)}>{"GEO"}</Typography>
            )}
            {tipo === 1 && (
              <Typography sx={styles.typeText(color)}>{"TOP"}</Typography>
            )}
            {tipo === 2 && (
              <Typography sx={styles.typeText(color)}>{"POP"}</Typography>
            )}
            {tipo === 3 && (
              <Stack direction="row" alignItems="center" gap={0.5}>
                <Typography sx={styles.typeText(color)}>{"FTTH"}</Typography>
                {ftthFilter && (
                  <Stack direction="row" gap={0.5} ml={1}>
                    {Object.keys(ftthFilter).includes("estados") && (
                      <Public sx={{ fontSize: 14, color: "white" }} />
                    )}
                    {Object.keys(ftthFilter).includes("cidades") && (
                      <LocationCity sx={{ fontSize: 14, color: "white" }} />
                    )}
                    {Object.keys(ftthFilter).includes("bairros") && (
                      <HomeWork sx={{ fontSize: 14, color: "white" }} />
                    )}
                    {Object.keys(ftthFilter).includes("pops") && (
                      <Lan sx={{ fontSize: 14, color: "white" }} />
                    )}
                    {Object.keys(ftthFilter).includes("olts") && (
                      <DeviceHub sx={{ fontSize: 14, color: "white" }} />
                    )}
                    {Object.keys(ftthFilter).includes("onus") && (
                      <Home sx={{ fontSize: 14, color: "white" }} />
                    )}
                  </Stack>
                )}
              </Stack>
            )}
          </Box>
          {canEdit && !inGroup && (
            <IconButton
              id="options-button"
              sx={styles.options}
              onClick={handleClick}
            >
              <MoreVert />
            </IconButton>
          )}

          <Stack gap={"5px"} mt={2}>
            <Typography sx={styles.title}>{mapName}</Typography>
            <Stack gap={"10px"} direction={"row"}>
              <Typography sx={styles.subtitle}>
                {totalCTOS + " CTOs"}
              </Typography>
              <Typography sx={styles.subtitle}>
                {totalONUS + " ONUs"}
              </Typography>
            </Stack>
          </Stack>
          <Divider width={"100%"} orientation="horizontal" />
          {/*         <Box>
          <Typography sx={styles.hostsNames}>
            {hostsNames.map((name, index) => {
              const newName = name + (index === 0 ? " " : " ,");
              return newName;
            })}
          </Typography>
        </Box> */}
          <Stack direction="row" sx={styles.alerts}>
            {/* <Typography sx={styles.title}>{"Alertas"}</Typography>{" "} */}
            <Typography variant="textFieldTitle" pr={1}>
              {"Alertas:  "}
            </Typography>

            <Stack direction="row" sx={styles.alertsIcons}>
              <AlertIcons
                styles={styles}
                number={`${
                  alertas.find((alert) => alert.severity === "1")?.value ?? 0
                }`}
                severity={"disaster"}
              />
              <AlertIcons
                styles={styles}
                number={`${
                  alertas.find((alert) => alert.severity === "0")?.value ?? 0
                }`}
                severity={"warning"}
              />
            </Stack>
          </Stack>
        </CardActionArea>
      </Tooltip>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "options-button",
        }}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <MenuList>
          <MenuItem
            onClick={() => {
              setOpenEditDialog(true);
            }}
          >
            <ListItemIcon>
              <Edit fontSize="small" color="primary" />
            </ListItemIcon>
            <ListItemText>Editar Mapa</ListItemText>
          </MenuItem>
          <MenuItem
            onClick={() => {
              // handleClose();
              //setOpenModalShare(true);
            }}
            onMouseEnter={(event) => {
              setAnchorElSubmenu(event.currentTarget);
            }}
            onMouseLeave={(event) => {
              setAnchorElSubmenu(null);
            }}
          >
            <ListItemIcon>
              <Share fontSize="small" color="primary" />
            </ListItemIcon>
            <Stack
              direction={"row"}
              width={"150px"}
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <ListItemText>Compartilhar</ListItemText>{" "}
              <ArrowRight
                fontSize="small"
                color="action"
                sx={{ transform: isMdDown ? "rotate(90deg)" : "none" }}
              />
            </Stack>
            <SubMenu
              anchorElSubmenu={anchorElSubmenu}
              openSubmenu={openSubmenu}
              setAnchorElSubmenu={setAnchorElSubmenu}
              handleClose={handleClose}
              setOpenModalShare={setOpenModalShare}
              handleCopy={handleCopy}
              hasLink={!!mapToken?.token && mapToken.status}
              theme={theme}
            />
          </MenuItem>
          {isAdmin && (
            <MenuItem
              onClick={() => {
                handleClose();
                setOpenModalAcessos(true);
              }}
            >
              <ListItemIcon>
                <LockPersonOutlined fontSize="small" color="primary" />
              </ListItemIcon>
              <ListItemText>Acessos</ListItemText>
            </MenuItem>
          )}
          {/* O mapa FTTH base (gerado automaticamente, sem filtros) não pode
              ser excluído — só os criados com filtros. */}
          {isFiltered && (
            <>
              <Divider />
              <MenuItem
                onClick={() => {
                  handleClose();
                  setOpenDeleteModal(true);
                }}
              >
                <ListItemIcon>
                  <Delete fontSize="small" color="primary" />
                </ListItemIcon>
                <ListItemText>Excluir Mapa</ListItemText>
              </MenuItem>
            </>
          )}
        </MenuList>
      </Menu>

      <ModalShareMap
        id={id}
        tipo={tipo}
        mapName={mapName}
        openModalShare={openModalShare}
        setOpenModalShare={setOpenModalShare}
        mapas={[...mapas, ...pops.filter(({ mapRefId }) => !!mapRefId)]}
        setSnackbar={setSnackbar}
        updateMapTokenInMaps={updateMapTokenInMaps}
        index={index}
        mapToken={mapToken}
      />
      <ModalAcessosMapa
        id={id}
        mapName={mapName}
        openModal={openModalAcessos}
        setOpenModal={setOpenModalAcessos}
        mapAccess={mapAccess}
        setSnackbar={setSnackbar}
        updateMapAccessInMaps={updateMapAccessInMaps}
        currentUserId={currentUserId}
      />
      <AlertModal
        openModal={openDeleteModal}
        setOpenModal={setOpenDeleteModal}
        confirmar={disableButton}
        handleButton={handleApiDelete}
        severity={"error"}
        singleButton={false}
      />
      <NewMapFtth
        openNovoMapaDialog={openEditDialog}
        setOpenNovoMapaDialog={setOpenEditDialog}
        updateTitleInMaps={updateTitleInMaps}
        setSnackbar={setSnackbar}
        editMode={true}
        initialData={{ id, titulo: mapName, ftthFilter }}
        mapIndex={index}
      />
    </Card>
  );
}
//export { CardMapsHome };
